"use client";

import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { useLocalNum } from "@faire/web/common/localization";
import { useFormatMoney } from "@faire/web/common/money";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { use } from "react";

export const SocialAdsIncentiveSubtitle: React.FC<{
  firstOrderIncentiveByCountryPromise: Promise<IFaireMoney>;
  totalBrandCountPromise: Promise<number>;
}> = (props) => {
  const { formatMoney } = useFormatMoney();
  const { localNum } = useLocalNum();

  const firstOrderIncentiveByCountry = use(
    props.firstOrderIncentiveByCountryPromise
  );
  const totalBrandCount = use(props.totalBrandCountPromise);

  return (
    <StrictLocalMsg
      id="dfWAAF"
      defaultMessage="Shop from more than {totalBrandCountNumber} independent brands and get up to {discountMoney} off—offer valid for 7 days after signup."
      description={{
        text: "subheading for discover page social ads variant",
        img: "https://cdn.faire.com/fastly/61bd2ff0c7f966c483138bff8e0fb38065edeb09c242bf8255bdcb9670a3f6c0.png",
      }}
      values={{
        discountMoney: formatMoney({
          money: firstOrderIncentiveByCountry,
          omitCentsIfZero: true,
          disableAutoConvertCurrency: true,
        }),
        totalBrandCountNumber: localNum(totalBrandCount),
      }}
    />
  );
};
